import { FunctionComponent, useEffect } from 'react';
import { Button, Typography } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import { getAuth } from 'firebase/auth';
import { useTranslation } from 'react-i18next';

const { Title, Text } = Typography;

const VerifyEmailSuccess: FunctionComponent = () => {
  const { t } = useTranslation(['auth']);
  const history = useHistory();

  useEffect(() => {
    const refreshToken = async () => {
      const auth = getAuth();
      if (auth.currentUser) {
        await auth.currentUser.reload();
        await auth.currentUser.getIdToken(true);
      }
    };

    refreshToken();
  }, []);

  return (
    <div className="text-center">
      <div className="flex justify-center mb-4">
        <div
          style={{
            width: 64,
            height: 64,
            borderRadius: '50%',
            backgroundColor: '#f0fff4',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <CheckCircleOutlined style={{ fontSize: 28, color: '#22c55e' }} />
        </div>
      </div>

      <Title level={3} style={{ marginBottom: 8 }}>
        {t<string>('verifyEmailSuccess.title')}
      </Title>

      <Text type="secondary" style={{ display: 'block', marginBottom: 24 }}>
        {t<string>('verifyEmailSuccess.description')}
      </Text>

      <Button type="primary" size="large" block onClick={() => history.push('/')}>
        {t<string>('verifyEmailSuccess.goToApp')}
      </Button>
    </div>
  );
};

export default VerifyEmailSuccess;
